import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listarMembros, Membro } from '../../api/scmmp';
import FotoMembro from '../../components/Membro/FotoMembro';
import Alert from '../../components/ui/Alert';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import { useAppSelector } from '../../hooks/use-app-selector';
import { useDebouncedValue } from '../../hooks/use-debounced-value';
import useHttp from '../../hooks/use-http';
import { removeAccents } from '../../shared/remove-accents';
import { AppRoutes } from '../../shared/routes';

const MembrosPage: React.FC = (): React.ReactElement => {
  const {
    sendRequest,
    status,
    error,
    data: membros,
  }: { data: Membro[]; error: string; status: string; sendRequest: any } = useHttp(listarMembros);

  const routerNavigate = useNavigate();
  const { token } = useAppSelector((state) => state.auth);
  const [membrosSorted, setMembrosSorted] = useState<Membro[]>([]);
  const [nomeFiltro, setNomeFiltro] = useState<string>('');
  const debouncedNomeFiltro = useDebouncedValue(nomeFiltro, 400);

  useEffect(() => {
    if (membros !== null) {
      let filteredMembros = [...membros];
      if (debouncedNomeFiltro !== undefined && debouncedNomeFiltro !== '') {
        filteredMembros = filteredMembros.filter((membro) =>
          removeAccents(membro.pessoaFisicaNome.toUpperCase()).includes(
            removeAccents(debouncedNomeFiltro.toUpperCase())
          )
        );
      }
      if (filteredMembros !== null) {
        setMembrosSorted(
          filteredMembros.sort((u1, u2) =>
            removeAccents(u1.pessoaFisicaNome).localeCompare(removeAccents(u2.pessoaFisicaNome))
          )
        );
      }

      setMembrosSorted(filteredMembros);
    }
  }, [membros, debouncedNomeFiltro]);

  useEffect(() => {
    sendRequest(token);
  }, [sendRequest, token]);

  const nomeOnChange = (nomeFiltro: string) => {
    setNomeFiltro(nomeFiltro);
  };

  const sincronizarClickHandler = (e: any, membro: Membro) => {
    e.preventDefault();
    // eslint-disable-next-line no-restricted-globals
    if (confirm('Deseja realmente enviar dados deste membro para o CNMP')) {
      routerNavigate(`${AppRoutes.MEMBROS_SINCRONIZAR}/${membro.id}/${membro.pessoaFisicaNome}`);
    }
  };

  const sincronizarTodosClickHandler = (e: any) => {
    e.preventDefault();
    // eslint-disable-next-line no-restricted-globals
    if (confirm('Deseja realmente enviar dados de TODOS os membros para o CNMP')) {
      routerNavigate(`${AppRoutes.MEMBROS_SINCRONIZAR}/todos/TODOS OS MEMBROS`);
    }
  };

  return (
    <div className="container">
      <h3 className="h3">Lista de membros</h3>
      {status !== 'completed' && <LoadingSpinner />}
      {status === 'completed' && error && <Alert message={error} type="danger" />}
      {status === 'completed' && !error && membrosSorted && (
        <>
          <section className="section">
            <form onSubmit={(event: React.FormEvent<HTMLFormElement>) => event.preventDefault()}>
              <div className="row">
                <div className="col  ">
                  <div className="form-group">
                    <label htmlFor="searchName">Nome</label>
                    <input
                      // ref={searchNameRef}
                      autoFocus
                      type="text"
                      className="form-control"
                      id="searchName"
                      placeholder="digite um nome"
                      // onKeyDown={nomeKeydownHandler}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        nomeOnChange(event.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="col  align-items-center align-self-center" style={{display:'none'}}>
                  <div className="form-group">
                    <button
                      className="btn  btn-danger mt-3"
                      onClick={(e) => sincronizarTodosClickHandler(e)}
                    >
                      Atualizar todos os membros
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </section>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Matrícula</th>
                <th></th>
                <th>Nome</th>
                <th>Dt. último envio</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {membrosSorted.map((membro) => (
                <tr key={membro.id}>
                  <td>{membro.matricula}</td>
                  <td>
                    <FotoMembro pessoaFisicaId={membro.pessoaFisicaId} />
                  </td>
                  <td>{membro.pessoaFisicaNome}</td>
                  <td>
                    {membro.dataUltimaSincronizacaoCnmp &&
                      new Date(membro.dataUltimaSincronizacaoCnmp).toLocaleDateString('pt-BR')}
                  </td>
                  <td>
                    <button
                      className="btn btn-primary"
                      onClick={(e) => sincronizarClickHandler(e, membro)}
                      // disabled={isEnviando}
                    >
                      {/* {isEnviando && enviandoMembroId === membro.id && (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                      {enviandoMembroId !== membro.id && <span>Enviar dados</span>} */}
                      Enviar dados
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default MembrosPage;
